import {UsersListToolbar} from './UserListToolbar'
import {UsersListSearchComponent} from "./UsersListSearchComponent";



const UsersListHeader = () => {

  return (
    <div className='card-header border-0 pt-6'>
      {/*<UsersListSearchComponent />*/}
      {/* begin::Card toolbar */}
      <div className='mb-9 card-toolbar d-flex align-items-center justify-content-between'>
        {/* begin::Group actions */}
          <UsersListToolbar />
          <UsersListSearchComponent/>
        {/* end::Group actions */}
      </div>
      {/* end::Card toolbar */}
    </div>
  )
}

export {UsersListHeader}
